import axios from 'axios';
import { toast } from 'react-hot-toast';

function getWixToken() {
  if(typeof window === 'undefined') {
    return null;
  }
  if(window.self === window.top) {
    return null;
  }
  const urlParams = new URLSearchParams(window.location.search);
  // user should always have a wix param when opening the app through the wix editor/dashboard
  const urlToken = urlParams.get('wix');
  if(urlToken) {
    sessionStorage.setItem('wix_auth', urlToken);
    urlParams.delete('wix');
    const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
    window.history.replaceState({}, '', newUrl);
    return urlToken;
  }
  return sessionStorage.getItem('wix_auth');
}

// Public pages (widgets, forms, surveys, walls of love) pass `withCredentials: false` on their calls: they never need
// the dashboard session, and the API does not let pages on other origins (custom domains, sandboxed embeds) send it.
const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE,
  withCredentials: true,
  timeout: 180000,
  transitional: {
    clarifyTimeoutError: true,
  },
  // required to fix ngrok CORS
  // headers: {
  //   'ngrok-skip-browser-warning': '1'
  // }
});

apiClient.interceptors.request.use(
  (config) => {
    const wixToken = getWixToken();
    if(wixToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers['x-wix-auth'] = wixToken;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      const errMessage = error && error.response ? error.response.data : null;
      if(errMessage) {
        if(error.response.status === 400 && errMessage.error.toLowerCase() === 'workspace not found') {
          // router.push('/');
          window.location.href = '/';
        }
        // else if(error.response.status === 401){
        // 	window.location.href = '/login';
        // }
        return Promise.resolve(errMessage);
      }
      if(error.code === 'ETIMEDOUT') {
        // toast.error('The request timed out, please try again later');
        return Promise.resolve({
          error: 'The request timed out, please try again later',
        });
      }
      return Promise.resolve({ error: error.message });
    } catch(e) {
      toast.error('Something went wrong...');
      return Promise.reject(e);
    }
  },
);
const { get, post, put, delete: destroy } = apiClient;
export { get, post, put, destroy, apiClient };
